"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HubMetrifyEvent = /** @class */ (function () {
    function HubMetrifyEvent(data) {
        if (data === void 0) { data = {}; }
        this.group = '';
        this.name = '';
        this.path = new URL(location.href).pathname;
        this.queryParams = new URL(location.href).search;
        Object.assign(this, data);
    }
    return HubMetrifyEvent;
}());
exports.default = HubMetrifyEvent;
